import { Box } from "@mui/material";
import { Participant, SearchParticipantProps } from "../interfaces/interfaces";
import React from "react";
import { SearchParticipantContext } from "../context/searchParticipantContext";
import RenderTile from "./renderTile";
import CustomPagination from "../../../components/pagination/customPagination";
import IPagination from "../../appointmentOverview/interface/iPagination";

const RenderResults = (): React.JSX.Element => {
  const {
    searchParameters,
    paginationSettings,
    setPaginationSettings,
    filteredResults,
  }: {
    searchParameters: SearchParticipantProps;
    paginationSettings: IPagination;
    setPaginationSettings: React.Dispatch<React.SetStateAction<IPagination>>;
    filteredResults?: Participant[] | undefined;
  } = React.useContext(SearchParticipantContext);

  return (
    <React.Fragment>
      {searchParameters.data !== null && filteredResults && (
        <React.Fragment>
          {filteredResults
            .slice(
              (paginationSettings.page - 1) * paginationSettings.rowsPerPage,
              paginationSettings.page * paginationSettings.rowsPerPage
            )
            .map((participant: Participant, index) => (
              <Box
                key={index}
                sx={{
                  backgroundColor: "grey.200",
                  p: 2,
                  mb: 2,
                  borderRadius: 2,
                }}
              >
                <RenderTile participant={participant} index={index} />
              </Box>
            ))}

          <CustomPagination
            items={filteredResults}
            paginationSettings={paginationSettings}
            setPaginationSettings={setPaginationSettings}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default RenderResults;
